import React, { useContext } from 'react'
import { useNavigate } from 'react-router-dom'

import { mpfWhoHttp } from '../../assets/ts/api/mpf-who-http'
import {
  getInquiries,
  getInquiryStatusCounts,
} from '../../assets/ts/data/inquiry/inquiry'
import usePiiAuditTrailMetadata from '../../hooks/pii/use-pii-audit-trail-metadata'
import usePiiCategoryTypeMetadata from '../../hooks/pii/use-pii-category-type-metadata'
import usePiiScanItemGroupedMetadata from '../../hooks/pii/use-pii-scan-item-grouped-metadata'
import usePiiScanMetadata from '../../hooks/pii/use-pii-scan-metadata'
import { MetadataContext } from '../../store/metadata-context-provider'
import { RoleContext } from '../../store/role-context-provider'
import { createDueOuts } from './testing-dueout'
import { createInquiries } from './testing-inquiry'

/**TestingPlayground:
 * This component was designed to empower developers, enabling them to thoroughly test their code without
 * the need to build atop existing components that might already be in active use.
 *
 * The fundamental concept revolves around developers utilizing this space to create Proof of Concepts (POCs),
 * enabling them to thoroughly test and refine their ideas before seamlessly transitioning them out of this environment
 * once the POC is successfully completed.
 */
const TestingPlayground = () => {
  const metadataContext = useContext(MetadataContext)
  const navigate = useNavigate()
  const { firstLevelPermission, isLoading } = useContext(RoleContext)
  const { fetchPiiAuditTrailMetadata, piiAuditTrailMetadata } = usePiiAuditTrailMetadata({
    isArchivedFilter: null,
  })
  const { fetchPiiCategoryTypeMetadata, piiCategoryTypeMetadata } = usePiiCategoryTypeMetadata({
    isArchivedFilter: null,
  })
  const { fetchpiiScanItemGroupedMetadata, piiScanItemGroupedMetadata } =
    usePiiScanItemGroupedMetadata({
      isArchivedFilter: null,
    })
  const { fetchPiiScanMetadata, piiScanMetadata } = usePiiScanMetadata({
    isArchivedFilter: null,
  })
  const NUM_INQUIRIES_TO_CREATE = 1000
  const NUM_DUEOUTS_TO_CREATE = 1000

  const handleCreateInquiries = () => {
    console.log(createInquiries(NUM_INQUIRIES_TO_CREATE, metadataContext))
  }

  const handleCreateDueOuts = () => {
    console.log(createDueOuts(NUM_DUEOUTS_TO_CREATE, metadataContext))
  }

  const handleLogInquiries = async () => {
    const results = await getInquiries({
      isArchivedFilter: false,
    })
    console.log(results)
  }

  const handleLogInquiryCounts = async () => {
    const results = await getInquiryStatusCounts({
      sectionCodeFilter: -1,
    })
  }
  
  if (!isLoading) {
    if (!firstLevelPermission) {
      navigate('/accessdenied')
    }
  }

  const buttonClasses = 'btn-border btn-lg btn-border-radius3 mx-2 p-3'
  return (
    <div>
      <div className='container d-flex align-items-center'>
        <button className={buttonClasses} onClick={() => console.log(metadataContext)}>
          Log MetadataContext
        </button>
        <button className={buttonClasses} onClick={handleCreateInquiries}>
          Create {NUM_INQUIRIES_TO_CREATE} Inquiries
        </button>
        <button className={buttonClasses} onClick={handleCreateDueOuts}>
          Create {NUM_DUEOUTS_TO_CREATE} Due Outs
        </button>
        <button className={buttonClasses} onClick={handleLogInquiries}>
          Log Inquiries
        </button>
        <button className={buttonClasses} onClick={handleLogInquiryCounts}>
          Log InquiryCounts
        </button>
        <button
          className={buttonClasses}
          onClick={async () => {
            console.log(await mpfWhoHttp().Me())
          }}
        >
          Log WhoHttp.Me()
        </button>
      </div>
    </div>
  )
}
export default TestingPlayground
